export default "__VITE_ASSET__7zCNQWf___"